module.exports = __webpack_public_path__ + "img/rec-title-3.a795867.png";